import { useRoutes } from 'react-router'
import { routes } from '../router/config'

export default function AppWithAuth() {
  // useRoutes를 사용하여 라우트 렌더링
  const element = useRoutes([...routes])

  return element
}
